var router = require('pjax').Router;
var index = require('./index.js');
var form = require('./form.js');
var task = require('./task.js');
var manage = require("./manage.js");

router.get('review-flow/:any', form);
router.get('review-flow', index);
router.get('entry/manage-reviews', manage);
router.get('entry/review/:any', task);
